import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Cómo accedo al contenido?',
  answer: 'Inmediatamente después de tu compra segura, recibirás un correo electrónico con tus credenciales y enlaces para descargar el Libro Principal y todos los bonos directamente en tu teléfono, tablet o computadora.'
}, {
  question: '¿Es seguro para cabello teñido o con keratina?',
  answer: 'Totalmente. El protocolo se aplica exclusivamente en el cuero cabelludo (la raíz), no en los medios ni puntas, por lo que no altera tintes, decoloraciones ni tratamientos químicos de alisado.'
}, {
  question: '¿Qué formas de pago aceptan?',
  answer: 'Aceptamos todas las tarjetas de crédito y débito principales (Visa, Mastercard, Amex), así como PayPal. Nuestro procesador de pagos es 100% seguro y encriptado.'
}, {
  question: '¿Pica o quema al aplicarlo?',
  answer: 'No quema. Sentirás un calor profundo y un cosquilleo estimulante. Es la vasodilatación trabajando, señal de que la sangre y el oxígeno están fluyendo hacia los folículos asfixiados.'
}, {
  question: '¿Huele fuerte a jengibre?',
  answer: 'El aroma es fresco y herbal al momento de aplicarlo, pero se evapora y desaparece en cuanto el cuero cabelludo lo absorbe. No dejará rastro de olor en tu cabello durante el día.'
}, {
  question: '¿Necesito utensilios especiales para prepararlo?',
  answer: 'No. Todo lo que necesitas está en tu cocina: un rallador o licuadora básica, un colador fino y agua. El proceso de extracción dura menos de 3 minutos.'
}, {
  question: '¿Hay soporte si tengo dudas?',
  answer: 'Sí, dentro del libro encontrarás nuestro correo de soporte prioritario para resolver cualquier duda que tengas sobre la aplicación o la preparación.'
}, {
  question: '¿Funciona en hombres con calvicie?',
  answer: 'El protocolo disuelve los tapones de DHT, que es la principal causa de alopecia androgénica (común en hombres). Si el folículo aún tiene vida (aunque sea vello muy fino), el protocolo puede ayudar a reactivarlo. Si la zona está completamente lisa y brillante desde hace años, el folículo ya está cerrado permanentemente.'
}, {
  question: '¿Cuánto tiempo tengo acceso a los materiales?',
  answer: 'Tu acceso es de por vida. Pagas una sola vez y puedes descargar los archivos cuantas veces quieras y tenerlos guardados para siempre.'
}, {
  question: '¿Hay actualizaciones gratis?',
  answer: 'Sí. Cualquier nueva edición o mejora al protocolo se enviará a tu correo electrónico sin ningún costo adicional.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-brand-dark" data-id="element-74">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-75">
        <h2 className="font-heading text-3xl font-bold text-center text-white mb-12" data-id="element-76">
          Dudas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, index) => {
          const isActive = openIndex === index;
          return <div key={index} className={`faq-item border border-white/10 rounded-lg bg-brand-card/50 overflow-hidden ${isActive ? 'active' : ''}`} data-id="element-78">
                <button className="faq-button w-full text-left p-5 flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(isActive ? null : index)} data-id="element-79">
                  <span className="font-medium text-white" data-id="element-80">{faq.question}</span>
                  <ChevronDownIcon className="w-5 h-5 text-brand-gold transition-transform duration-300 faq-icon" data-id="element-81" />
                </button>
                <div className="faq-answer px-5 bg-black/20 text-gray-400 font-light text-sm" data-id="element-82">
                  <div className="pb-5" data-id="element-83">{faq.answer}</div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}